/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-let */

type Arr = Array<string | null | undefined>;

const useShowComponent = (prevArr: Arr, compArr: Arr) => {
  const [visible, setVisible] = React.useState(false);

  const compareArray = (array1: Arr, array2: Arr) => {
    let compare = true;
    if (array1.length !== array2.length) compare = false;

    array1.forEach((el, i) => {
      if (el !== array2[i]) {
        if (array2[i] === undefined || array2[i] === null) {
          if (el !== "") {
            compare = false;
          }
        } else {
          compare = false;
        }
      }
    });

    return compare;
  };

  React.useEffect(() => {
    setVisible(!compareArray(prevArr, compArr));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(prevArr), JSON.stringify(compArr)]);

  return visible;
};

export { useShowComponent };
